import * as React from 'react';
import { Button } from '@teamsnap/teamsnap-ui';

import './ConfirmDeletePopup.scss';

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

const ConfirmDeletePopup = React.forwardRef<HTMLDivElement, Props>(
  ({ isOpen, onCancel, onDelete }, ref) => (
    <>
      {isOpen && (
        <div ref={ref} role='dialog' className='Popup ConfirmDeletePopup'>
          <div className='Popup-container Popup-container--left is-open'>
            <div className='Popup-content'>
              <h4>Delete waiver?</h4>
              <div className='Popup-buttons'>
                <Button
                  mods='u-spaceRightSm'
                  onClick={e => {
                    e.stopPropagation();
                    onCancel();
                  }}
                >
                  Cancel
                </Button>

                <Button
                  color='primary'
                  onClick={e => {
                    e.stopPropagation();
                    onDelete();
                  }}
                >
                  Delete
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
);

export default ConfirmDeletePopup;
